import usePermissions from "../hooks/usePermissions";
import { PermissionsContext } from "./permissionsContext";

export { PermissionsContext };

const PermissionsProvider = ({ children }) => {
  const permissions = usePermissions();
  return (
    <PermissionsContext.Provider value={permissions}>
      {children}
    </PermissionsContext.Provider>
  );
};

export default PermissionsProvider;
